"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isProfileTracker(object) {
    return checkProfileTracker(object).fulfilled;
}
exports.isProfileTracker = isProfileTracker;
function checkProfileTracker(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("name"), __1.hasChoice("type", ["register", "last"]), __1.hasChoice("provider", ["adjust", "web", "transactional"])).withOptions(options).explain();
}
exports.checkProfileTracker = checkProfileTracker;
//# sourceMappingURL=ProfileTracker.js.map